import { useLanguage } from "../contexts/LanguageContext";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ctaAnimation = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function CTASection() {
  const { t } = useLanguage();

  return (
    <section data-testid="cta-section" className="relative py-16 md:py-20 bg-[#131b2f]">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1a6cf5]/5 rounded-full blur-[120px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
        <motion.div
          {...ctaAnimation}
        >
          <h2
            data-testid="cta-h2"
            className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-6"
          >
            {t("cta.h2")}
          </h2>
          <p
            data-testid="cta-text"
            className="font-outfit text-base md:text-lg text-[#94a3b8] max-w-2xl mx-auto mb-10 leading-relaxed"
          >
            {t("cta.text")}
          </p>
          <Link
            to="/contact"
            data-testid="cta-button"
            className="inline-flex items-center gap-2 bg-[#1a6cf5] hover:bg-[#3b82f6] text-white font-outfit px-8 py-4 rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-[#1a6cf5]/25 text-lg"
          >
            {t("cta.button")}
            <ArrowRight size={20} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
